import { apiGetMLInfo, apiResetML } from '../../../../common/api/magic-links'

const fetchMagicLinkInfo = token => ({
  requestPrefix: 'MAGIC_LINK:FETCH_INFO',
  params: { token },
  request: () => apiGetMLInfo(token)
})

const resendMagicLink = id => ({
  requestPrefix: 'MAGIC_LINK:SEND_ANOTHER',
  request: () => apiResetML(id)
})

export { fetchMagicLinkInfo, resendMagicLink }
